import "./register.css";
import "../../assets/css/style.css";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import React, { Fragment, useEffect, useState } from "react";
import BrandLogoTop from "../../components/BrandLogo/BrandLogoTop";
import BrandLogoEnd from "../../components/BrandLogo/BrandLogoEnd";

// Firebase auth
import Auth from "../../components/auth/auth";

import registerCoverPhoto from "../../assets/login/register1.svg";

// Form Validate imports Start
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// Form Validate imports End

import { useDispatch } from "react-redux";
import SocialAuthProviders from "../../components/SocialAuthProviders/SocialAuthProviders";
import useRegister from "./scripts/hook";
import PhoneVerificationComponent from "../../components/PhoneVerificationComponent/PhoneVerificationComponent";
import TopSVG from "./Icons/TopSVG.js";
import { ToastContainer } from "react-toastify";

import logo from "../../assets/login/logo.svg";

// Form Validate schema Start
const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must have at least 3 characters")
    .max(30, "Name must not be more than 30 characters")
    .required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  business: yup
    .string()
    .min(3, "Name must have at least 3 characters")
    .max(30, "Business name must not be more than 30 characters")
    .required("Business name is required"),
  password: yup
    .string()
    .min(6, "Password must be greater than 5 characters")
    .required("Password is required"),
  phone: yup.string().required("Phone number is required").nullable(),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords does not match"),
});

// Form Validate schema End

const Register = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setError: setFormError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [
    ,
    ,
    ,
    ,
    ,
    CodeSent,
    setCodeSent,
    VerifyCode,
    Error,
    setError,
    ButtonLoader,
    goBack,
    RegisterUsingEmail,
  ] = useRegister();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const [FormDisabled, setFormDisabled] = useState(false);

  const RegisterUser = async (e) => {
    // return;
    setFormDisabled(true);
    if (e.phone !== "" || e.phone !== null || e.phone !== undefined) {
      if (isValidPhoneNumber(e.phone)) {
        const res = await RegisterUsingEmail(e);
        if (res !== false) {
          dispatch({
            type: "ADD_NEW_USER",
            payload: res,
          });
          // window.location.pathname = "/";
          navigate("/verify/email");
        }
      } else {
        setFormError("phone", {
          message: "Enter a valid phone number",
        });
        setFormDisabled(false);
        return;
      }
    }
    setFormDisabled(false);
  };
  // Initialize a boolean state
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

  // Password toggle handler
  const togglePassword = () => {
    // When the handler is invoked
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  // Password toggle handler
  const toggleConfirmPassword = () => {
    // When the handler is invoked
    // inverse the boolean state of confirmPasswordShown
    setConfirmPasswordShown(!confirmPasswordShown);
  };
  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 575) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <>
      <ToastContainer />

      <div className="register-page-container">
        <div className="register-page-content">
          <div className="auth-content-container">
            <div className="register-cover-photo">
              <img src={registerCoverPhoto} alt="img" />
            </div>
            <div className="register-auth-form">
              <div className="register-logo-top">
                <BrandLogoTop />
              </div>
              <div className="register-top-svg">
                <img src={registerCoverPhoto} alt="img" />
              </div>
              <div className="register-form-container">
                <form onSubmit={handleSubmit(RegisterUser)}>
                  <h2 className="form-heading">Registration</h2>
                  <div className="form-group register-form-group-style">
                    <input
                      type="text"
                      className="form-control form-input-field"
                      placeholder="Enter your name"
                      name="name"
                      defaultValue={searchParams.get("name")}
                      {...register("name")}
                      disabled={FormDisabled}
                    />
                    <small className="errorMessage">
                      {errors?.name?.message}
                    </small>
                  </div>
                  <div className="form-group register-form-group-style">
                    <input
                      type="email"
                      className="form-control form-input-field"
                      placeholder="Enter Your Email Address"
                      defaultValue={searchParams.get("email")}
                      {...register("email")}
                      disabled={FormDisabled}
                    />

                    <small className="errorMessage">
                      {errors?.email?.message}
                    </small>
                  </div>
                  <div className="form-group register-form-group-style">
                    <PhoneInputWithCountry
                      name="phone"
                      className="form-control form-phone-input-field"
                      defaultCountry={"PK"}
                      international={true}
                      countryCallingCodeEditable={false}
                      initialValueFormat="national"
                      //                           // smartCaret={true}
                      control={control}
                      rules={{
                        validate: (value) => isValidPhoneNumber(value),
                        required: true,
                      }}
                      style={{ border: "none !important" }}
                      disabled={FormDisabled}
                      defaultValue={searchParams.get("phone") ?? ""}
                    />

                    <small className="errorMessage">
                      {errors?.phone?.message}
                    </small>
                  </div>

                  <div className="form-group register-form-group-style">
                    <input
                      type="text"
                      className="form-control form-input-field"
                      placeholder="Enter Your Business name"
                      name="business"
                      defaultValue={searchParams.get("businessName")}
                      {...register("business")}
                      disabled={FormDisabled}
                    />
                    <small className="errorMessage">
                      {errors?.business?.message}
                    </small>
                  </div>
                  <div className="form-group register-form-group-style">
                    <span
                      onClick={togglePassword}
                      className={`register-pass-icon ${
                        passwordShown
                          ? "bi bi-eye-fill"
                          : "bi bi-eye-slash-fill"
                      } `}
                    ></span>
                    <input
                      type={passwordShown ? "text" : "password"}
                      className="form-control form-input-field"
                      placeholder="Enter Your Password"
                      {...register("password")}
                      disabled={FormDisabled}
                    />

                    <small className="errorMessage">
                      {errors?.password?.message}
                    </small>
                  </div>
                  <div className="form-group register-form-group-style">
                    <span
                      onClick={toggleConfirmPassword}
                      className={`register-pass-icon ${
                        confirmPasswordShown
                          ? "bi bi-eye-fill"
                          : "bi bi-eye-slash-fill"
                      } `}
                    ></span>
                    <input
                      type={confirmPasswordShown ? "text" : "password"}
                      className="form-control form-input-field"
                      placeholder="Confirm Password"
                      {...register("confirmPassword")}
                      disabled={FormDisabled}
                    />

                    <small className="errorMessage">
                      {errors?.confirmPassword?.message}
                    </small>
                  </div>
                  <div id="recapt"></div>
                  <div className="text-center ">
                    <button
                      id="recaptcha"
                      type="submit"
                      className="py-2  form-submit-button"
                      disabled={FormDisabled}
                    >
                      {FormDisabled && (
                        <span className="spinner-border spinner-border-sm mr-1"></span>
                      )}
                      Register Account
                    </button>
                  </div>
                </form>
                <div className="all-ready-have-acc mt-2">
                  <p>
                    Already have an account?&nbsp;
                    <Link to="/login" className="text-primary">
                      <u>Login</u>
                    </Link>
                  </p>
                </div>
                {CodeSent && (
                  <PhoneVerificationComponent
                    {...{
                      VerifyCode,
                      setCodeSent,
                      setError,
                      Error,
                      ButtonLoader,
                      goBack,
                    }}
                  />
                )}
                {/* <SocialAuthProviders /> */}
              </div>
            </div>
            <div className="logo-end">
              <BrandLogoEnd />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
